import styled from 'styled-components';
import { AllieText } from '../../Text';

export const MulticolorBarStyled: any = styled.div<{
  disabled: boolean;
  showArrow?: boolean;
  arrowColor?: string;
  overflow?: string;
  display?: string;
}>`
  flex-wrap: nowrap;
  height: ${(props: any) => props.height || '13px'};
  overflow: ${(props: any) => props.overflow || 'hidden'};
  opacity: ${(props) => (props.disabled ? 0.5 : 1)};
  ${(props) => `${props.display ? `display: ${props.display}` : ''}`};

  .bar {
    float: left;
    height: 100%;
    position: relative;
    &:first-of-type {
      border-top-left-radius: ${(props: any) => props.borderRadius || 5}px;
      border-bottom-left-radius: ${(props: any) => props.borderRadius || 5}px;
    }

    &:last-of-type {
      border-top-right-radius: ${(props: any) => props.borderRadius || 5}px;
      border-bottom-right-radius: ${(props: any) => props.borderRadius || 5}px;
    }

    &:nth-last-child(2):after {
      content: '';
      position: absolute;
      bottom: -10px;
      right: -10px;
      border: 10px solid transparent;
      border-bottom: 10px solid
        ${(props) => (props.arrowColor ? props.arrowColor : 'var(--allie-color-neutral-40)')};
      visibility: ${(props) => (props.showArrow ? 'visible' : 'hidden')};
    }
  }
`;

export const StyledRemainingText = styled(AllieText)`
  text-align: center;
`;
